

module.exports = __webpack_require__.stylable.create(
    "AddToCartButton3432622508",
    {"classes":{"root":"AddToCartButton3432622508__root","addToCartButton":"AddToCartButton3432622508__addToCartButton"},"vars":{},"stVars":{"buttonAddToCartBackground":"'\"fallback(color(--addToCart_actionButtonbackgroundColor), color(color-8))\"'","buttonAddToCartColor":"'\"fallback(color(--addToCart_actionButtontextColor), color(color-1))\"'","buttonAddToCartFont":"'\"fallback(font(--addToCart_actionButtontextFont), font({theme: 'Body-M', size: '15px'}))\"'","buttonAddToCartBorderWidth":"'\"fallback(font(--addToCart_actionButtonborderSize), string(0))\"'","buttonAddToCartBorderColor":"'\"fallback(color(--addToCart_actionButtonborderColor), color(color-5))\"'","buttonAddToCartBorderRadius":"'\"fallback(font(--addToCart_actionButtoncornersRadius), unit(0,px))\"'"},"keyframes":{}},
    "",
    8,
    "AddToCartButton3432622508",
    null
);
